const headers = {
  name: "Account Mapping",
  navigate: {
    tabs: [
      {
        name: "Settings",
        path: "/app/settings",
      },
      {
        name: "Account Mapping",
        path: "",
      },
    ],
  },
};

export default headers;